export const URGENCY = {
  emergenza: { label: "Emergenza", cls: "bg-red-600 text-white" },
  alta: { label: "Alta", cls: "bg-orange-500 text-white" },
  normale: { label: "Normale", cls: "bg-blue-500 text-white" },
  bassa: { label: "Bassa", cls: "bg-gray-400 text-white" },
};

export const STATUS_LABELS = {
  nuova: "Nuova",
  da_verificare: "Da verificare",
  in_attesa_informazioni: "In attesa informazioni",
  da_approvare: "Da approvare",
  fornitore_da_individuare: "Fornitore da individuare",
  richiesta_inviata: "Richiesta inviata",
  in_attesa_fornitore: "In attesa fornitore",
  intervento_programmato: "Intervento programmato",
  intervento_in_corso: "Intervento in corso",
  in_attesa_preventivo: "In attesa preventivo",
  in_attesa_decisione: "In attesa decisione",
  in_attesa_assemblea: "In attesa assemblea",
  in_attesa_assicurazione: "In attesa assicurazione",
  risolta: "Risolta",
  chiusa: "Chiusa",
  sospesa: "Sospesa",
  annullata: "Annullata",
};

export const STATUS_ORDER = Object.keys(STATUS_LABELS);

export const CATEGORY_LABELS = {
  perdita_acqua: "Perdita d'acqua", infiltrazione: "Infiltrazione", ascensore: "Ascensore",
  riscaldamento: "Riscaldamento", acqua_calda: "Acqua calda", impianto_elettrico: "Impianto elettrico",
  cancello: "Cancello", citofono: "Citofono", pulizie: "Pulizie", rifiuti: "Rifiuti",
  rumori: "Rumori", odori: "Odori", fumi: "Fumi", sicurezza: "Sicurezza", incendio: "Incendio",
  parti_comuni: "Parti comuni", danni: "Danni", assicurazione: "Assicurazione",
  lavori_straordinari: "Lavori straordinari", morosita: "Morosità",
  richiesta_documenti: "Richiesta documenti", richiesta_contabile: "Richiesta contabile",
  contestazione: "Contestazione", comportamento_condomini: "Comportamento condòmini", altro: "Altro",
};

export const catLabel = (k) => CATEGORY_LABELS[k] || (k || "").replace(/_/g, " ");
